import { TIMER_STATUS, WEIGHT_UNIT } from '../../../../../../../types/enum';
import { convertWeight } from '../../../../../../../lib/utils';
import ReactPlayer from 'react-player';
import usePreference from '../../../../../../../hook/usePreference';

const VodPlayer = ({ url }) => {
  return (
    <ReactPlayer
      url={url}
      width='100%'
      height='100%'
      muted={true}
      playing={true}
      loop={true}
      playsinline={true}
      style={{
        border: '1px solid white',
      }}
    />
  );
};

const ExerciseName = ({ name }) => {
  return (
    <div className='absolute left-0 bg-black bg-opacity-60 text-white rounded-full px-1 text-sm line-clamp-1'>
      {name}
    </div>
  );
};

const NextTag = () => {
  return (
    <div className='absolute bottom-1 right-1 bg-black bg-opacity-60 text-white rounded-full px-1 text-[10px]'>
      Next
    </div>
  );
};

const DropsetTag = () => {
  return (
    <div className='absolute top-1 right-1 bg-black bg-opacity-60 text-white rounded-full px-1 text-[10px]'>
      Dropset
    </div>
  );
};

const NextExercise = ({ url, name, isTargetStatus, isDropset }) => {
  return (
    <div
      className={`absolute right-4 bottom-4 rounded-xl overflow-hidden border-2 border-white transition-all ${
        isTargetStatus ? 'w-2/5' : 'w-1/5'
      }`}
    >
      <VodPlayer url={url} />
      <NextTag />
      {isDropset && <DropsetTag />}
      <ExerciseName name={name} />
    </div>
  );
};

const SmallTag = ({ text }) => {
  return (
    <div className='bg-black bg-opacity-60 text-white rounded-xl px-2 text-[10px] italic'>
      {text}
    </div>
  );
};

const Display = ({
  status,
  getViewTimeFormat,
  routine,
  totalRanTime,
  cycle,
  currentExercise,
  currentSet,
  currentExerciseIndex,
  currentGroupIndex,
  cycleExerciseCount,
  totalCycleExerciseCount,
  nonCycleSetCount,
  totalNonCycleExerciseCount,
}) => {
  const { preference } = usePreference();

  return (
    routine &&
    currentSet &&
    currentExercise && (
      <div className='h-4/6 overflow-auto relative flex justify-center'>
        <div className='relative'>
          <VodPlayer url={currentExercise.vodUrl} />
          <div className='absolute top-0 w-full h-1/4 bg-gradient-to-b from-white'></div>
          <div className='absolute bottom-0 w-full h-1/4 bg-gradient-to-t from-white'></div>
        </div>
        <div className='absolute top-0 w-full h-full'>
          <div className='absolute flex justify-between w-full'>
            <div className='text-xs'>
              <div className='font-bold'>
                {routine.cycleRoutine ? (
                  <span>
                    Cycle {cycle} / {routine.cycle}
                  </span>
                ) : (
                  <span>
                    Set {nonCycleSetCount} /{' '}
                    {totalNonCycleExerciseCount[currentGroupIndex].sets}
                  </span>
                )}
              </div>
              <div className='opacity-40'>
                {getViewTimeFormat(totalRanTime)}
              </div>
            </div>
            <div className='text-right text-xs'>
              {routine.cycleRoutine ? (
                <div className='font-bold'>
                  Exercise {cycleExerciseCount} / {totalCycleExerciseCount}
                </div>
              ) : (
                <div className='font-bold'>
                  Exercise {currentExerciseIndex + 1} /{' '}
                  {currentSet?.sets?.length}
                </div>
              )}
              <div className='flex flex-col items-end gap-1 mt-1'>
                {currentExercise.dropset && <SmallTag text='Dropset' />}
                {currentExercise.maxout && <SmallTag text='Max-out' />}
                {currentExercise.weight ? (
                  <SmallTag
                    text={`${
                      preference.weightUnit === WEIGHT_UNIT.LB
                        ? `${convertWeight(
                            currentExercise.weight,
                            WEIGHT_UNIT.KG,
                            WEIGHT_UNIT.LB
                          )} lb`
                        : `${currentExercise.weight} kg`
                    }`}
                  />
                ) : null}
              </div>
            </div>
          </div>
          {currentSet.sets[currentExerciseIndex + 1] && (
            <NextExercise
              url={currentSet.sets[currentExerciseIndex + 1].vodUrl}
              name={currentSet.sets[currentExerciseIndex + 1].name}
              isTargetStatus={status === TIMER_STATUS.REST}
              isDropset={currentSet.sets[currentExerciseIndex + 1].dropset}
            />
          )}
          {currentExerciseIndex === currentSet.sets.length - 1 &&
            currentGroupIndex !== routine.groups.length - 1 && (
              <NextExercise
                url={
                  routine.groups[currentGroupIndex + 1].exerciseSet.sets[0]
                    .vodUrl
                }
                name={
                  routine.groups[currentGroupIndex + 1].exerciseSet.sets[0].name
                }
                isTargetStatus={status === TIMER_STATUS.SET_REST}
                isDropset={
                  routine.groups[currentGroupIndex + 1].exerciseSet.sets[0]
                    .dropset
                }
              />
            )}
          {currentExerciseIndex === currentSet.sets.length - 1 &&
            currentGroupIndex === routine.groups.length - 1 &&
            cycle !== routine.cycle && (
              <NextExercise
                url={routine.groups[0].exerciseSet.sets[0].vodUrl}
                name={routine.groups[0].exerciseSet.sets[0].name}
                isTargetStatus={status === TIMER_STATUS.CYCLE_REST}
                isDropset={routine.groups[0].exerciseSet.sets[0].dropset}
              />
            )}
        </div>
      </div>
    )
  );
};

export default Display;
